import dayjs from 'dayjs';
import 'dayjs/locale/ja';

dayjs.locale('ja');

export default dayjs;

export function safeParseTime(time: string | undefined): dayjs.Dayjs | undefined {
  return time != null ? dayjs(time) : undefined;
}

export function formatDayAndTime(time: dayjs.Dayjs | undefined): string {
  if (time) {
    return time.format('M/D(ddd) HH:mm');
  } else {
    return '';
  }
}

export function formatTime(time: dayjs.Dayjs | undefined): string {
  if (time) {
    return time.format('HH:mm');
  } else {
    return '';
  }
}

export function isSameDay(t1: dayjs.Dayjs | undefined, t2: dayjs.Dayjs | undefined): boolean {
  if (t1 == null || t2 == null) return false;
  return t1.year() === t2.year() && t1.month() === t2.month() && t1.date() === t2.date();
}

